/* Envuelto en una IIFE con guarda, mismo patron que dd0-quote-slider.js y dd0-cart-blocks.js.
   La seccion emite su propio <script src>, asi que con DOS instancias de "DD0 - Desplegable" en
   la misma pagina el navegador ejecuta este fichero dos veces. Con la clase en el ambito global
   la segunda ejecucion muere entera con "Identifier 'DD0CollapsibleGroup' has already been
   declared" ANTES de correr una linea, y ahi se lleva por delante el customElements.define:
   los desplegables de la pagina se quedan sin el "solo uno abierto a la vez".
   Dentro de la IIFE la clase es local y no hay nada que redeclarar. */
(() => {
  if (customElements.get('dd0-collapsible-group')) return;

  class DD0CollapsibleGroup extends HTMLElement {
    connectedCallback() {
      this.singleOpen = this.dataset.singleOpen === 'true';
      this.rows = Array.from(this.querySelectorAll('details.dd0-cc__row'));

      if (this.singleOpen) {
        let firstOpen = null;
        this.rows.forEach((row) => {
          if (row.open) {
            if (firstOpen === null) firstOpen = row;
            else row.open = false;
          }
        });
      }

      this.rows.forEach((row) => {
        const summary = row.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => this.onSummaryClick(e, row));
      });
    }

    onSummaryClick(e, row) {
      if (!this.singleOpen) return;
      if (row.open) return;
      this.rows.forEach((other) => {
        if (other !== row && other.open) other.open = false;
      });
    }
  }

  customElements.define('dd0-collapsible-group', DD0CollapsibleGroup);
})();
